import React from 'react'
import BlueHeading from '../other/common/BlueHeading';
import Heading from '../common/ui/Heading';

const Transforming = () => {
  return (
    <>
      <div className="pb-[140px] px-4 max-xl:pb-[120px] max-lg:pb-24 max-md:pb-20 max-sm:pb-10">
        <div className="max-w-[871px] mx-auto flex items-center justify-center flex-col">
          <BlueHeading text="Transformative Stories" />
          <Heading children="Why Are These Interviews Important?" className='text-center ' />
          <p className="text-[#5E5C5C] font-normal leading-[150%] text-center text-[26px] max-md:text-base pt-4">
            Every interview is more than just a conversation—it’s a beacon of
            guidance for millions. Deepak Ji’s insights, thoughts, and lived
            experiences help today’s youth reshape the direction of their lives.
          </p>
        </div>
          </div>
          <div className='h-[210px]'></div>
    </>
  );
}

export default Transforming